"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Information = function Information(props) {
  var id = props.id,
    _props$width = props.width,
    width = _props$width === void 0 ? 26 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 26 : _props$height,
    _props$color = props.color,
    color = _props$color === void 0 ? '#6F6F6F' : _props$color,
    _props$title = props.title,
    title = _props$title === void 0 ? 'Information' : _props$title,
    _props$description = props.description,
    description = _props$description === void 0 ? 'Information' : _props$description;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 26 26"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title), /*#__PURE__*/_react["default"].createElement("desc", null, description), /*#__PURE__*/_react["default"].createElement("g", {
    id: "UI-Design_Final",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Tenant-User_My-Access",
    transform: "translate(-22.000000, -751.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Information-Selected",
    transform: "translate(23.000000, 752.000000)"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    id: "Oval-Copy-3",
    stroke: color,
    strokeWidth: "1.75",
    fill: color,
    cx: "12",
    cy: "12",
    r: "12"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.7265625,7.99 C10.7348909,7.99 10.2390625,7.56417092 10.2390625,6.7125 C10.2390625,5.84916235 10.7348909,5.4175 11.7265625,5.4175 C12.7182341,5.4175 13.2140625,5.84916235 13.2140625,6.7125 C13.2140625,7.56417092 12.7182341,7.99 11.7265625,7.99 Z M12.9165625,18 L10.5190625,18 L10.5190625,9.25 L12.9165625,9.25 L12.9165625,18 Z",
    id: "i-copy-3",
    fill: "#FFFFFF"
  })))));
};
Information.propTypes = _index.iconProps;
var _default = Information;
exports["default"] = _default;